import { object } from 'yup';
import * as validationSchema from './validationSchema';

export const loginValidation = object().shape({
  idNum: validationSchema.idNumSchema,
  password: validationSchema.passwordSchema,
});
